import {PAGE_HEADER_TYPE_HERO_WITH_SIDE_IMAGE} from '@/modules/page/sanity/page-head/hero-with-side-image-container/constants';
import {HERO_WITH_SIDE_IMAGE_FRAGMENT} from '@/modules/page/sanity/page-head/hero-with-side-image-container/query';
import {PAGE_HEADER_TYPE_TEXT_HEADING} from '@/modules/page/sanity/page-head/text-heading-container/constants';
import {TEXT_HEADING_FRAGMENT} from '@/modules/page/sanity/page-head/text-heading-container/query';
import type {PageBySlugQueryResult} from '@/sanity/schemas/types';

export const PAGE_HEADINGS_FRAGMENT = `//groq
	...,
	_type == "${PAGE_HEADER_TYPE_HERO_WITH_SIDE_IMAGE}" => {
		${HERO_WITH_SIDE_IMAGE_FRAGMENT}
	},
	_type == "${PAGE_HEADER_TYPE_TEXT_HEADING}" => {
		${TEXT_HEADING_FRAGMENT}
	}
`;

export type PageHeadingsFragment = NonNullable<NonNullable<PageBySlugQueryResult>['pageHeadings']>;
